import EnglishJSON from '../../components/MultiLanguage/en-US.json'
import SpanishJSON from '../../components/MultiLanguage/es-ES.json'
import PortugueseJSON from '../../components/MultiLanguage/pt-BR.json'
import ChineseJSON from '../../components/MultiLanguage/zh-Hans.json'
import VietnameseJSON from '../../components/MultiLanguage/vi-VI.json'
import HaitianJSON from '../../components/MultiLanguage/fr-HT.json'
import * as actionTypes from './actionTypes'
import * as constants from '../../constants/text'

// Language Update Service
export function getLanguage (languageCode) {
  return dispatch => {
    dispatch(selectedLanguageAction(languageCode))

    switch (languageCode) {
      case constants.EN:
        dispatch(getLanguageFulfilledAction(EnglishJSON))
        break
      case constants.ES:
        dispatch(getLanguageFulfilledAction(SpanishJSON))
        break
      case constants.PT:
        dispatch(getLanguageFulfilledAction(PortugueseJSON))
        break
      case constants.ZH:
        dispatch(getLanguageFulfilledAction(ChineseJSON))
        break
      case constants.VI:
        dispatch(getLanguageFulfilledAction(VietnameseJSON))
        break
      case constants.HI:
        dispatch(getLanguageFulfilledAction(HaitianJSON))
        break
      default:
        dispatch(getLanguageFulfilledAction(EnglishJSON))
        break
    }
  }
}

function getLanguageFulfilledAction (constantStrings) {
  return {
    type: actionTypes.GET_LANGUAGE_FULFILLED,
    payload: constantStrings
  }
}

function selectedLanguageAction (SelectedLanguage) {
  return {
    type: actionTypes.UPDATE_SELECTED_LANGUAGE,
    payload: SelectedLanguage
  }
}

export function changeLanguage (language) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_LANGUAGE,
      payload: language
    })
  }
}

export function showFeedBack (flag = false) {
  return dispatch => {
    dispatch({
      type: actionTypes.GET_FEEDBACK,
      payload: flag
    })
  }
}

export function hideFeedBack (flag = false) {
  return dispatch => {
    dispatch({
      type: actionTypes.HIDE_FEEDBACK,
      payload: flag
    })
  }
}
